module.exports = __webpack_public_path__ + "static/media/healthfy-chat.11266ae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/healthfy-chat.jpg
// module id = 839
// module chunks = 0